import { DataSource, Role, User } from '@fulcrumapp/fulcrum-core';
import { createObjectCache } from '../hooks/use-app';
import LayerSettings from '../models/layer-settings';
import ApiDataSource from '../shared/api-data-source';
import LocalStoragePreferences from '../utils/local-storage-preferences';
import { AppState } from './app.slice';

interface ElementWithDataset extends Element {
  dataset: {
    component: string;
    props: string;
  }
}

const appInitialState = (): AppState => {
  const state: AppState = {
    api: undefined,
    dataSource: undefined,
    globals: undefined,
    layerSettings: undefined,
    objectCache: undefined,
    params: undefined,
    preferences: undefined,
    restRole: undefined,
    restUser: undefined,
    role: undefined,
    user: undefined,
  };

  [...document.querySelectorAll<ElementWithDataset>('[data-component]')].forEach((element) => {
    const { props } = element.dataset;
    const { params, ...globals } = JSON.parse(props);

    const objectCache = createObjectCache();
    const dataSource = new DataSource();
    const apiDataSource = new ApiDataSource(globals.token, '/api/v2', globals.config);
    dataSource.add(apiDataSource);

    const { client: api } = apiDataSource;
    const { user: restUser, role: restRole } = globals;
    const user = new User(restUser);
    const role = new Role(restRole);

    const preferences = new LocalStoragePreferences();
    const layerSettings = new LayerSettings(
      globals.layers ?? [],
      params.form_id,
      globals.config.tile_url,
      globals.config.layer_url ?? globals.config.tile_url,
      preferences,
    );

    state.api = api;
    state.dataSource = dataSource;
    state.globals = globals;
    state.layerSettings = layerSettings;
    state.objectCache = objectCache;
    state.params = params;
    state.preferences = preferences;
    state.restRole = restRole;
    state.restUser = restUser;
    state.role = role;
    state.user = user;
  });

  return state;
};

export default appInitialState;
